import * as React from 'react';
import { IconProps } from '../types';

const IcPassword = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none' {...props}>
    <g clipPath='url(#clip0_13531_16670)'>
      <path
        d='M18.5021 9.04185H8.38337C7.96426 7.28555 6.38757 5.98828 4.51152 5.98828C2.29619 5.98828 0.499969 7.7845 0.499969 9.99984C0.499969 12.2152 2.29619 14.0114 4.51152 14.0114C6.38757 14.0114 7.96425 12.7141 8.40333 10.9578H13.651V12.8937C13.651 12.9935 13.7309 13.0933 13.8506 13.0933H15.2685C15.3682 13.0933 15.468 13.0135 15.468 12.8937V12.1553C15.468 12.0555 15.5479 11.9557 15.6676 11.9557H16.446C16.5458 11.9557 16.6456 12.0356 16.6456 12.1553V12.8937C16.6456 12.9935 16.7254 13.0933 16.8451 13.0933H18.063C18.1628 13.0933 18.2626 13.0135 18.2626 12.8937V10.9578H18.542C19.0809 10.9578 19.5 10.5387 19.5 9.99984C19.4601 9.48093 19.0409 9.04185 18.5021 9.04185ZM4.51152 12.0954C3.35396 12.0954 2.41594 11.1574 2.41594 9.99984C2.41594 8.84227 3.35396 7.90425 4.51152 7.90425C5.66909 7.90425 6.60711 8.84227 6.60711 9.99984C6.60711 11.1574 5.66909 12.0954 4.51152 12.0954Z'
        fill={props?.fill ?? '#1D2129'}
      />
    </g>
    <defs>
      <clipPath id='clip0_13531_16670'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export default IcPassword;
